import React, { useEffect, useState } from 'react'
import { getHeaders } from '@sportninja/common/api/request'
import EnvHandler from '@sportninja/common/utils/env-handler-setup'
import Pusher from 'pusher-js'

export const PusherContext = React.createContext(undefined)

const PusherContextProvider = ({ children, isLoggedIn }) => {
  const [isReady, setIsReady] = useState(false)
  const [client, setClient] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    const setup = async () => {
      const url = await EnvHandler.get()
      const wsHost = await EnvHandler.getWsHost()
      const wsKey = await EnvHandler.getWsKey()
      const headers = await getHeaders(true)
      const authorization = headers.get('authorization')

      try {
        const pusher = new Pusher(wsKey, {
          wsHost: wsHost?.replace('https://', ''),
          wsPort: 6501,
          wssPort: 6001,
          // wsPort: __DEV__ ? 80 : 6501,
          // wssPort: __DEV__ ? 443 : 6001,
          forceTLS: false,
          disableStats: true,
          enabledTransports: ['ws', 'wss'],
          authEndpoint: `${url}/auth/broadcasting/team`,
          auth: {
            headers: {
              Authorization: authorization,
              Accept: 'application/json',
            },
          },
        })

        pusher.connection.bind('connected', () => {
          setError(false)
          setClient(pusher)
          setIsReady(true)
        })

        pusher.connection.bind('error', () => {
          setIsReady(false)
          setError(true)
        })
      } catch (e) {
        return null
      }
    }

    if (isLoggedIn) {
      setup()
    } else {
      if (client && typeof client.disconnect === 'function') {
        client.disconnect()
      }
    }
  }, [isLoggedIn])

  return (
    <PusherContext.Provider value={{ client, isReady, error }}>
      {children}
    </PusherContext.Provider>
  )
}

export default PusherContextProvider
